import React, { ReactElement, useEffect, useState } from 'react';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { createGlobalStyle } from 'styled-components';
import { DataStatisticApi, FilterApi, PrMrPopupApi } from '../../utils/api';

const ApiStatus = () => {
  //variable
  const [statusParam, setStatusParam] = useState<number>();
  const [statusInstall, setStatusInstall] = useState<number>();
  const [statusAlarm, setStatusAlarm] = useState<number>();

  //get all API Status
  const apiStatus = async () => {
    //diagperm-parameters
    try {
      const paramResponse = await DataStatisticApi.getObjectList();
      setStatusParam(paramResponse.status);
    } catch (e) {
      console.log(e);
    }

    //diagperm-installationlegacy
    try {
      const installResponse = await FilterApi.getCpos();
      setStatusInstall(installResponse.status);
    } catch (e) {
      console.log(e);
    }
    ///diagperm-alarmsmeasures
    try {
      const alarmsResponse = await PrMrPopupApi.getMeasure(
        '16102PR00014',
        '2023-01-01'
      );
      setStatusAlarm(alarmsResponse.status);
    } catch (e) {
      console.log(e);
    }
  };

  function renderStatus(status: any, phrase: any): ReactElement {
    let content;
    return content;
  }

  useEffect(() => {
    apiStatus();
  }, []);

  return (
    <Container>
      <Styles />
      <Card>
        <Word
          value='STATUS DES APIS'
          textStyle='title'
          variant='h1'
          automatedTestId='api-search-word'
        />
        <Container className='liste'>
          {renderStatus(statusParam, ' parameters')}
          {renderStatus(statusInstall, ' installationlegacy')}
          {renderStatus(statusAlarm, '  alarmsmeasures')}
        </Container>
      </Card>
    </Container>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
    .liste{
      flex-direction: row;
      /* align-self:center; */
    }

    #api-success-word, #api-error-word{
      align-self:center;
    }
    .status-bloc-success,.status-bloc-error{
      width: 20%;
      margin: 5%
    }
}`;
export default ApiStatus;
